import React from 'react';
import { useNavigation } from 'react-day-picker';
import Icon from '@anwb/icon';
import { getMonths, getYears } from '../helpers';
import { CaptionContainer, CaptionMonthButton, CaptionSelect } from '../styles';
export const Caption = ({ reference, toMonth, fromMonth }) => {
    const { currentMonth, goToMonth, goToDate } = useNavigation();
    const months = getMonths();
    const years = getYears({ from: fromMonth, to: toMonth });
    const month = currentMonth.getMonth();
    const year = currentMonth.getFullYear();
    /**
     *
     * It could be that the current month is not in the list of years, this can happen when the restriction
     * (fromMonth, toMonth) don't include the current month.
     */
    if (year < years[0]) {
        years.unshift(year);
    }
    else if (year > years[years.length - 1]) {
        years.push(year);
    }
    const nextMonth = () => {
        goToDate(new Date(year, month + 1));
    };
    const previousMonth = () => {
        goToDate(new Date(year, month - 1));
    };
    const handleMonthChange = (event) => {
        const selectedMonth = parseInt(event.target.value, 10);
        const newDate = new Date(currentMonth);
        newDate.setMonth(selectedMonth);
        goToMonth(newDate);
    };
    const handleYearChange = (event) => {
        const selectedYear = parseInt(event.target.value, 10);
        const newDate = new Date(currentMonth);
        newDate.setFullYear(selectedYear);
        goToDate(newDate);
    };
    return (React.createElement(CaptionContainer, null,
        React.createElement(CaptionMonthButton, { type: "button", onClick: previousMonth },
            React.createElement(Icon, { variant: "chevron-left" })),
        React.createElement(CaptionSelect, { reference: `${reference}-caption-month`, name: "caption-month", value: String(month), onChange: handleMonthChange, colorContext: "on-medium" }, months.map((m, index) => {
            return (React.createElement("option", { key: m, value: index }, m));
        })),
        React.createElement(CaptionSelect, { reference: `${reference}-caption-year`, name: "caption-year", value: String(year), onChange: handleYearChange, colorContext: "on-medium" }, years.map((y) => {
            return (React.createElement("option", { key: y, value: y }, y));
        })),
        React.createElement(CaptionMonthButton, { type: "button", onClick: nextMonth },
            React.createElement(Icon, { variant: "chevron-right" }))));
};
//# sourceMappingURL=Caption.js.map